import MuxPlayer from '@mux/mux-player-react/lazy';

const Temp = () => {
  return (
    <div className='flex flex-col my-10 space-y-2 justify-center h-screen w-full items-center'>
      <br />
      <br />
      <br />
      <br />

      <div style={{ position: 'relative', paddingTop: '5%', height: '100%', width: '60%' }}>
        <MuxPlayer
          accentColor='#ea580c'
          autoPlay={true}
          metadata={{
            // video_id: 'njgvXU02ajdGi02qHCq51fnCHpXDDPNRZsCVbwZnZY3VM',
            video_title: 'Test video title',
          }}
          playbackId='OMWNwVYBDL7lwwj5MdQ6e3P28S00zAYqaQ8SuVKfX02ZI'
          streamType='on-demand'
          tokens={{
            playback:
              'eyJhbGciOiJSUzI1NiJ9.eyJraWQiOiJGWmJCRFhnU05FdHNEbG9TVHlHM2NUQUtsMDIwMFdzdlZTN3NuS2ROdWN6alEiLCJzdWIiOiJPTVdOd1ZZQkRMN2x3d2o1TWRRNmUzUDI4UzAwekFZcWFROFN1VktmWDAyWkkiLCJhdWQiOiJ2IiwiZXhwIjoxNzYzMzg4ODQ4fQ.ibyeFVMYrD9bj1RiIxNccJmlGovebru5WmfbYey-zibIlX28byBeRU5fteur7RPdRvU8D0fJC7IaR0l0z-6NZ6wfMreMcAW5DbuuA4_wfv1wIj5FF-ZtAsTQcMqWIJh-q8bSianhkvN8J0cGUaCxsYXrsJJkFBSRF6vl_KagJdcs6pchMtenHcG-4gnvVWAxAxUrhtIFtlr8DNnJszhI1WnodCqvgr47Pou6oNLAN_cnPePLeD1hRdSDCrQGX3rSIAvuTKO8ytwGKNww1i-iUcFPefYQ-yo0bWoXt4pkKrtuJTxt8wF-lfCLpVBoaprzbf0W-3vdLdhiSRXuhf1Q4g',
            thumbnail:
              'eyJhbGciOiJSUzI1NiJ9.eyJraWQiOiJGWmJCRFhnU05FdHNEbG9TVHlHM2NUQUtsMDIwMFdzdlZTN3NuS2ROdWN6alEiLCJzdWIiOiJPTVdOd1ZZQkRMN2x3d2o1TWRRNmUzUDI4UzAwekFZcWFROFN1VktmWDAyWkkiLCJhdWQiOiJ0IiwiZXhwIjoxNzYzMzg4ODQ4fQ.khNRk7C9nvB1TKJJlUIE1KTHiGSNZ5iGB73Hrx3U-3E87WBdysvOVf2tL8hw1jsd7MbqeqqsAISdM-M4PTK8dBLCh7mbq28kUKkYzeM_ArPYWbABmie4W5JfxFZsFln4ELdm7MRXsh3Nlgx3OUhGFAe_PtC5_BPEvIAH5gfV_MYF4w4S02bkyNEdSpHU8Xl24GkmIbcy28TQCHE4_jv9l0oNDiO3nXA5xfUp1GfmjhtDdk-uCnwyig26_ePNXLh4J1bGrxVGOhUbmKyTYYKi-U-cE0xWLY7fNDDvp-lRY10QygIS-I80g555wRTeWaU7Sjp3ennUkoW8Lc1JPmG5SA',
          }}
        />
      </div>

      <br />

      {/* <div style='position:relative;padding-top:56.25%;'>
        <iframe
          src='https://player.mediadelivery.net/embed/521362/2eef3411-7b25-45d6-86d7-5cb18af99b4f?token=40017d23154a973d3208c77baa32614b3f45b5b6c47723b549e92f98ccdd7d3f&expires=1762242882&autoplay=false&loop=false&muted=false&preload=false&responsive=true'
          loading='lazy'
          style='border:0;position:absolute;top:0;height:100%;width:100%;'
          allow='accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;'
          allowfullscreen='true'
        ></iframe>
      </div> */}
      <div style={{ position: 'relative', height: '100%', width: '60%' }}>
        {/** biome-ignore lint/a11y/useIframeTitle: <need> */}
        <iframe
          src='https://iframe.mediadelivery.net/embed/521362/f068717b-ba18-43ae-8e5a-ce15fd96a7f4?token=b15eb8f81f53f6810131a9ac0492f3673e1526d5fc6ec56f5c1e585aa942c95c&expires=1763388848'
          loading='lazy'
          style={{ width: '100%', border: 'none', aspectRatio: '16/9' }}
          allow='accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;'
          allowFullScreen
        ></iframe>
      </div>
    </div>
  );
};

export default Temp;
